import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from './app.breadcrumb.service';
import { AppMainComponent } from './app.main.component';
import { AppService } from './core/services/app.service';
import { CustomerService } from './core/services/customer.service';
import { FocuslinkService } from './core/services/focuslink.service';
import { GoogleAnalyticsService } from './core/services/google-analytics.service';
import { LocalDataStoreService } from './core/services/local-data-store.service';
import { UserService } from './core/services/user.service';
import { OOVenueService } from './core/services/venue-service';

@Component({
	selector: 'app-topbar',
	templateUrl: './app.topbar.component.html',
	styleUrls: ['./modules/commandCenter/commandcenter.scss'],
})
export class AppTopBarComponent implements OnInit, OnDestroy, OnChanges {
	displayProfile: boolean = false;
	subscription: Subscription;
	userKey: string;

	items: MenuItem[];

	selectedVenueKey: number;

	constructor(
		public breadcrumbService: BreadcrumbService,
		public app: AppMainComponent,
		public appService: AppService,
		private focuslink: FocuslinkService,
		private googleAnalytics: GoogleAnalyticsService,
		private localStorage: LocalDataStoreService,
		private router: Router,
		public userService: UserService,
		public venueService: OOVenueService,
		public customerService: CustomerService
	) {
		this.subscription = breadcrumbService.itemsHandler.subscribe((response) => {
			this.items = response;
		});
	}

	ngOnInit() {
		this.subscription.add(
			this.venueService.changeVenue.subscribe((venue) => {
				this.changeVenue(venue.key, `venueService.changeVenue`);
			})
		);
		this.subscription.add(
			this.userService.userVenues.subscribe((data) => {
				if (data.length > 0) {
					if (!this.selectedVenueKey) {
						this.selectedVenueKey = this.userService.userSubscription.value.preferences.venueDefault || data[0].venueKey;
					}
					if (!data.some((i) => i.venueKey === this.selectedVenueKey)) {
						this.selectedVenueKey = this.userService.userSubscription.value.preferences.venueDefault || data[0].venueKey;
					}

					this.changeVenue(this.selectedVenueKey, `userService.userVenues`);
				}
			})
		);
		// this.subscription.add(
		// 	this.venueService.subscriptionVenue.subscribe((venue) => {
		// 		venue && venue.key && this.customerService.initCustomerService(true);
		// 	})
		// );

		this.reload();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	ngOnChanges(changes: SimpleChanges) {}

	async changeVenue(venueKey, source) {
		this.appService.devLog(`changeVenue init with ${venueKey} from ${source}`);
		if (venueKey && venueKey !== this.venueService.subscriptionVenue.value.key) {
			this.router.navigate([this.userService.userSubscription.value.preferences.menuDefault]);
			this.selectedVenueKey = venueKey;
			this.appService.loading(true);

			this.appService.devLog(`Changing venue to ${venueKey} from ${source}`);
			this.localStorage.set('venueKey', venueKey);
			this.venueService.assignVenue(venueKey);
		}
	}

	async logout() {
		this.userService.logout();
		this.venueService.venueMessageDisconnect();
		this.router.navigate(['login']);
	}

	async reload() {
		if (!this.venueService.subscriptionVenue.value.key && this.userService.userVenues.value.length === 0) {
			this.userService.initUser(await this.localStorage.get('user'), await this.localStorage.get('utoken'));
			const ldsVenueKey = await this.localStorage.get('venueKey');
			// console.log(`ldsKeyValue ${ldsVenueKey}`);
			// console.log(`ldsKeyState = ${await this.localStorage.check("venueKey")}`);
			if (ldsVenueKey) {
				this.appService.devLog(`reloading with venueKey ${ldsVenueKey} (lds	)`);
				this.changeVenue(ldsVenueKey, `topBar.reload LDS`);
				return;
			}
		} else if (this.userService.userVenues.value.length > 0) {
			this.appService.devLog(`reloading with venueKey ${this.userService.userVenues.value[0]?.venueKey} (userVenues)`);
			this.changeVenue(this.userService.userVenues.value[0]?.venueKey, `topBar.reload userVenues`);
		}
	}
}
